import { FC, SVGProps } from 'react';

export const ToTopIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={24}
      fill="none"
      {...props}
    >
      <path
        id="icon/navigation/arrow_upward_24px"
        d="M13.5 18.7912V7.62123L18.38 12.5012C18.77 12.8912 19.41 12.8912 19.8 12.5012C20.19 12.1112 20.19 11.4812 19.8 11.0912L13.21 4.50123C13.0231 4.31397 12.7695 4.20874 12.505 4.20874C12.2405 4.20874 11.9868 4.31397 11.8 4.50123L5.19997 11.0812C4.80997 11.4712 4.80997 12.1012 5.19997 12.4912C5.58997 12.8812 6.21997 12.8812 6.60997 12.4912L11.5 7.62123V18.7912C11.5 19.3412 11.95 19.7912 12.5 19.7912C13.05 19.7912 13.5 19.3412 13.5 18.7912Z"
        fill="white"
      />
    </svg>
  );
};
